import { useState, useEffect } from 'react';

function useSpeechToText() {
  const [listening, setListening] = useState(false);
  const [recognition, setRecognition] = useState(null);
  const [transcript, setTranscript] = useState('');
  const [transcriptHistory, setTranscriptHistory] = useState([]);

  useEffect(() => {
    function initializeRecognition() {
      if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
        const newRecognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();

        newRecognition.continuous = true; 

        newRecognition.onstart = () => {
          setListening(true);
        };

        newRecognition.onresult = (event) => {
          const last = event.results.length - 1;
          const text = event.results[last][0].transcript;

          // Ajouter le texte au texte actuel
          setTranscript(prevTranscript => prevTranscript + ' ' + text);
          // Ajouter le texte au tableau de l'historique
          setTranscriptHistory(prevHistory => [...prevHistory, text]);
        };

        setRecognition(newRecognition);
      } else {
        console.log('Speech recognition is not supported in this browser.');
      }
    }

    initializeRecognition();

    return () => {
      if (recognition) {
        recognition.stop();
        setListening(false);
      }
    };
  }, []);

  const toggleListening = () => {
    if (recognition) {
      if (listening) {
        recognition.stop();
        setListening(false);
      } else {
        recognition.start();
        setTranscript('');
      }
    } else {
      console.log('Speech recognition is not supported in this browser.');
    }
  };

  return { transcript, transcriptHistory, listening, toggleListening };
}

export default useSpeechToText;
